import { render, staticRenderFns } from "./PackingProgress.vue?vue&type=template&id=bd24be4a&"
import script from "./PackingProgress.vue?vue&type=script&lang=js&"
export * from "./PackingProgress.vue?vue&type=script&lang=js&"
import style0 from "./PackingProgress.vue?vue&type=style&index=0&id=bd24be4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports